"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogLinkExterno = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var heading_1 = require("../../token/heading");
var tags_ga_1 = require("../../utils/tags-ga");
var button_1 = require("../button/button");
var checkbox_1 = require("../checkbox/checkbox");
var styles_1 = require("./styles");
var DialogLinkExterno = function (_a) {
    var actions = _a.actions, labelHeader = _a.labelHeader, contentTitle = _a.contentTitle, hideCheckbox = _a.hideCheckbox, onClick = _a.onClick, onChangeEventProps = _a.onChangeEventProps, onCloseClickProps = _a.onCloseClickProps, componenteDescricao = _a.componenteDescricao, tagOnChangeEvent = _a.tagOnChangeEvent, tagOnClickContinuar = _a.tagOnClickContinuar, tagOnClickFechar = _a.tagOnClickFechar;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var isMobile = (0, temas_frontend_1.useMobile)();
    var _b = (0, react_1.useState)(null), parent = _b[0], setParent = _b[1];
    var _c = (0, react_1.useState)(false), naoVisualizarMensagem = _c[0], setNaoVisualizarMensagem = _c[1];
    (0, react_1.useEffect)(function () {
        if (!parent) {
            var p = document.createElement('div');
            document.body.appendChild(p);
            setParent(p);
        }
        return function () {
            if (parent) {
                document.body.removeChild(parent);
            }
        };
    }, [parent]);
    if (!parent) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var dialogState = actions.dialogState;
    var onCloseClick = function () {
        dialogState(false);
        onCloseClickProps && onCloseClickProps();
    };
    var onChangeEvent = function () {
        var novoEstado = !naoVisualizarMensagem;
        if (novoEstado && onChangeEventProps) {
            onChangeEventProps();
        }
        setNaoVisualizarMensagem(novoEstado);
    };
    return react_dom_1.default.createPortal(react_1.default.createElement(styles_1.DialogLinkExternoStyled, { ariaLabel: "gap-link-externo", onClickOutSide: onCloseClick, className: "dialogLinkExterno", header: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.DialogHeaderContentStyled, null, isMobile ? (react_1.default.createElement(heading_1.H6, { color: theme.black, className: "dialogTitle" }, labelHeader)) : (react_1.default.createElement(heading_1.H5, { color: theme.black, bold: true, className: "dialogTitle" }, labelHeader))),
            react_1.default.createElement(tags_ga_1.TagsGa, { category: tagOnClickFechar === null || tagOnClickFechar === void 0 ? void 0 : tagOnClickFechar.category, action: tagOnClickFechar === null || tagOnClickFechar === void 0 ? void 0 : tagOnClickFechar.action, label: tagOnClickFechar === null || tagOnClickFechar === void 0 ? void 0 : tagOnClickFechar.label, eventType: 'clique' },
                react_1.default.createElement(styles_1.DialogHeaderCloseBtnStyled, { "aria-label": "fecha-link-externo", onClick: onCloseClick },
                    react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.X, size: "md" })))), content: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(styles_1.DialogContentStyled, null,
                react_1.default.createElement(heading_1.H5, { bold: true, color: theme.black, className: "dialogContentText" }, contentTitle || 'Você está sendo direcionado para um link externo.'),
                !!componenteDescricao && react_1.default.createElement(styles_1.ComponenteDescricaoStyled, null, componenteDescricao()),
                !hideCheckbox && (react_1.default.createElement(styles_1.DialogContentChkbxStyled, null,
                    react_1.default.createElement(checkbox_1.Checkbox, { gaAction: tagOnChangeEvent === null || tagOnChangeEvent === void 0 ? void 0 : tagOnChangeEvent.action, gaCategory: tagOnChangeEvent === null || tagOnChangeEvent === void 0 ? void 0 : tagOnChangeEvent.category, gaLabel: tagOnChangeEvent === null || tagOnChangeEvent === void 0 ? void 0 : tagOnChangeEvent.label, id: "NaoVisualizarNovamenteEstaMensagem", label: "N\u00E3o visualizar novamente esta mensagem", labelColor: theme.grey001, labelSmall: true, initialState: false, value: naoVisualizarMensagem, onChange: onChangeEvent }))),
                react_1.default.createElement(button_1.Button, { gaAction: tagOnClickContinuar === null || tagOnClickContinuar === void 0 ? void 0 : tagOnClickContinuar.action, gaCategory: tagOnClickContinuar === null || tagOnClickContinuar === void 0 ? void 0 : tagOnClickContinuar.category, gaLabel: tagOnClickContinuar === null || tagOnClickContinuar === void 0 ? void 0 : tagOnClickContinuar.label, label: "Continuar", primary: true, large: true, className: "btnAcaoLinkExterno", "data-testid": "click-continuar", onClick: function () { return onClick(naoVisualizarMensagem); } }))) }), parent);
};
exports.DialogLinkExterno = DialogLinkExterno;
